let notices = require( './notices' );

let vibe_cake_masters_login_bar = function( $ ) {

	let $body,
		$toggles,
		$bar,
		anim_speed = 400;

	let _init = function() {
		$body    = $( 'html body' );
		$toggles = $( '.toggle-login-bar' );
		$bar     = $( '#cake-masters-login-bar' );

		if ( $bar.length > 0 && $toggles.length > 0 ) {
			setup_toggles();

			_setup_form();
		}
	};

	let _setup_form = function() {
		$bar.find( 'form' ).on( 'submit', function ( e ) {
			e.preventDefault();

			$( this ).loading();

			login( $bar.find( 'input[name="masters-login-email"]' ).val(), $bar.find( 'input[name="masters-login-password"]' ).val(), true, $bar );
		} );

		$bar.on( 'masters-login_success masters-login_success_teacher', ( e, response ) => {
			notices.add_notice( $bar.find( '.form-notices' ), 'success', 'Success redirecting...' );
		} );

		$bar.on( 'masters-login_error', ( e, response ) => {
			$bar.find( 'form' ).loaded();

			if ( response.error ) {
				notices.add_notice( $bar.find( '.form-notices' ), 'error', response.error );
			}
		} )
	};

	let login = function ( email, password, refresh_page = true, $element_to_refresh ) {
		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_login_ajax_login_nonce,
			action: 'vibe_cake_masters_login_ajax_login',
			email: email,
			password: password,
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			console.log( typeof response );

			if ( typeof response === 'string' ) {
				// A teacher has logged in
				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					$element_to_refresh.trigger( 'masters-login_success_teacher', response );
				}

				if ( refresh_page ) {
					window.location.reload();
				}
			} else if ( response.success ) {
				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					$element_to_refresh.trigger( 'masters-login_success', response );
				}

				if ( refresh_page ) {
					window.location.reload();
				}
			} else {

				if ( $element_to_refresh && $element_to_refresh.length > 0 ) {
					$element_to_refresh.trigger( 'masters-login_error', response );
				}
			}
		} )
	};

	let setup_toggles = function() {
		$toggles.not( '.initialised' ).each( ( index, item ) => {
			let $link = $( item );

			$link.on( 'click', (e) => {
				e.preventDefault();
				toggle();
			} );

			$link.addClass( 'initialised' );
		} );

		$( document ).on( 'keydown', ( e ) => {
			if ( e.key === 'Escape' ) {
				close();
			}
		} );

		$body.find( '*' ).on( 'click', ( e ) => {
			if ( $body.hasClass( 'masters-open-login-bar' ) && ! e.target.matches( '#cake-masters-login-bar, #cake-masters-login-bar *, .toggle-login-bar' ) ) {
				close();
			}
		} );
	};

	let toggle = function() {
		if ( $bar.hasClass( 'animating' ) ) {
			return;
		}

		$bar.addClass( 'animating' );

		if ( $body.hasClass( 'masters-open-login-bar' ) ) {
			close();
		} else {
			open();
		}

		setTimeout( () => {
			$bar.removeClass( 'animating' );
		}, anim_speed )
	};

	let open = function() {
		$body.addClass( 'masters-open-login-bar' );
		$bar.slideDown( anim_speed );

		$body.trigger( 'masters-login-bar_opening' );

		setTimeout( () => {
			$body.trigger( 'masters-login-bar_opened' );
		}, anim_speed );
	};

	let close = function() {
		$body.removeClass( 'masters-open-login-bar' );
		$bar.slideUp( anim_speed );

		$body.trigger( 'masters-login-bar_closing' );

		setTimeout( () => {
			$body.trigger( 'masters-login-bar_closed' );
		}, anim_speed );
	};

	$( document ).ready( _init );

	return {
		toggle: toggle,
		open: open,
		close: close,
	};

} ( jQuery );

module.exports = vibe_cake_masters_login_bar;